export class ConvertBytes {
  // tslint:disable-next-line:jsdoc-format
  /** Esta clase permite convertir Bytes a KB, MB .GB .TB. PB, ETC.*/
  static format(bytes: number, decimals) {
    const byteFormat = Number(bytes);
    if (byteFormat === 0) {
      return '0 Bytes';
    }
    const kilobyte = 1024;
    const decimal = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const unitType = Math.floor(Math.log(bytes) / Math.log(kilobyte));
    return parseFloat((bytes / Math.pow(kilobyte, unitType)).toFixed(decimal)) + ' ' + sizes[unitType];
  }
}
